import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

const CustomerCtx = createContext(null);

const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("bl_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("bl_customer_token");
    if (!token) {
      setCustomer(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await customerApi.get("/customers/me");
      setCustomer(data);
    } catch {
      localStorage.removeItem("bl_customer_token");
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const register = async (payload) => {
    const { data } = await customerApi.post("/customers/register", payload);
    localStorage.setItem("bl_customer_token", data.access_token);
    setCustomer(data.customer);
    return data.customer;
  };

  const login = async (email, password) => {
    const { data } = await customerApi.post("/customers/login", { email, password });
    localStorage.setItem("bl_customer_token", data.access_token);
    setCustomer(data.customer);
    return data.customer;
  };

  const logout = () => {
    localStorage.removeItem("bl_customer_token");
    setCustomer(null);
  };

  const myOrders = async () => {
    const { data } = await customerApi.get("/customers/me/orders");
    return data;
  };

  return (
    <CustomerCtx.Provider value={{ customer, loading, register, login, logout, myOrders }}>
      {children}
    </CustomerCtx.Provider>
  );
}

export const useCustomerAuth = () => {
  const ctx = useContext(CustomerCtx);
  if (!ctx) throw new Error("useCustomerAuth must be used inside CustomerAuthProvider");
  return ctx;
};
